<template>
  <div class="w-100" :id="id">
    <el-input
        v-if="open"
        :id="'input-' + id"
        min="0"
        :type="type == 'comment' ? 'textarea' : 'number'"
        :rows="type == 'comment' ? 4 : 1"
        inputmode="numeric"
        class="new-report-input"
        v-model="edit_value"
        @keydown.tab.native="editValue('tab')"
        @keypress.enter.exact.native="editValue('enter')"
        @keydown.esc.native="editValue('esc')"
        @change="!editing ? editValue() : ''"
        @blur="!editing ? editValue() : ''"
    />

    <div v-else class="flex-row w-100">
      <div v-if="type === 'media_and_if'" class="flex-row w-100">
        <div class="new-report-media-profile pointer" @click="openInfluencer(value && value.account_name)">
          <div class="data-table-th-picture report pointer">
            <img :src="value && value.profile_picture_url" class="report-media-profile-img" @error="imgError" />
            <favorite :favorite="value && value.favorite" :index="index" referer="report" />
          </div>
          <div class="report-media-profile-namearea">
            <div class="report-media-profile-accountname">
              {{ value && value.account_name }}
              <img src="../../assets/badge.png" v-show="value && value.badge" style="width:14px;height:14px" />
            </div>
            <div class="report-media-profile-name">{{ value && value.name }}</div>
          </div>
        </div>
        <div class="flex-space"></div>
        <div class="pointer" style="position:relative">
          <el-image :src="mediaSrc" class="new-report-media" @click="openInfluencer(value && value.account_name)">
            <div slot="error" class="detail-img error new-report-media" @click="openInfluencer(value && value.account_name)">
              <font-awesome-icon :icon="['fas','exclamation-circle']" />
            </div>
          </el-image>
          <div class="pr_type" v-show="value && value.pr_flag">
            <div class="pr_tag">PR</div>
          </div>
          <div class="media_type report">
            <font-awesome-icon :icon="['far','play']" class="media_tag report" />
          </div>
          <el-tooltip content="通常の投稿よりも良いエンゲージメント率です。" placement="right">
            <div class="fine-egr" v-show="value && value.fine_egr">
              <font-awesome-icon :icon="['fas','check']" />
            </div>
          </el-tooltip>
        </div>
      </div>

      <div
          v-else-if="type === 'caption'"
          class="new-report-caption-cell pointer"
          @click.stop.prevent="openInfluencer(value && value.account_name)"
      >
        <pre class="new-report-caption-pre">{{ (value && value.caption) ? value.caption : "\u00A0" }}</pre>
      </div>

      <div v-else-if="['number', 'cost', 'cost_setting'].includes(type)">
        <span v-if="hasValue(value)">
          <template v-if="type === 'number'">{{ value | addComma }}</template>
          <template v-else>¥{{ value | addComma }}</template>
        </span>
        <span v-else style="color:#aaa">
          <i v-if="editable" class="el-icon-edit" />
          <font-awesome-icon v-else :icon="['far','hourglass-half']" style="color:#ccc" />
        </span>
      </div>

      <div v-else-if="type === 'percent'">
        <span v-if="hasValue(value)">{{ value | formatPercent }}%</span>
        <span v-else>
        <font-awesome-icon :icon="['far','hourglass-half']" style="color:#ccc" />
        </span>
      </div>

      <div v-else-if="type === 'comment'">
        <span v-if="hasValue(value)">{{ value }}</span>
        <span v-else style="color:#aaa">
          <i class="el-icon-edit" /> コメントを入力できます
        </span>
      </div>

      <div v-else-if="type === 'gender'">
        <div class="data-table-th-gender" v-if="hasValue(value)">
          <genderRatio :female_ratio="getRatioValue(value)" :male_ratio="Math.round((100 - getRatioValue(value)) * 10)/10" />
        </div>
        <span v-else><font-awesome-icon :icon="['far','hourglass-half']" style="color:#ccc"/></span>
      </div>

      <div v-else-if="type === 'diff'">
        <span v-if="typeof value === 'number' && value > 0" style="color:#0a0">+{{ value | addComma }}</span>
        <span v-else-if="typeof value === 'number' && value === 0" style="color:#666">{{ value }}</span>
        <span v-else-if="typeof value === 'number' && value < 0" style="color:#a00">{{ value | addComma }}</span>
        <span v-else><font-awesome-icon :icon="['far','hourglass-half']" style="color:#ccc" /></span>
      </div>

      <div v-else>
        <span v-if="hasValue(value)">{{ value }}</span>
      </div>
    </div>

    <div class="report-value-desc" v-show="column !== 'caption'">
      <span v-show="!editable">編集不可</span>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const changeReportPostAPI = root + "/api/report/change_report_post";

import favorite from "../list/favorite";
import genderRatio from "../list/gender_ratio";

export default {
  name: "reportPostValueTiktok",
  props: ["report_id", "media_id", "column", "index", "id", "value", "type", "editable", "sns_type"],
  components: { favorite, genderRatio },
  data() {
    return {
      open: false,
      editing: false,
      edit_value: "",
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() { return this.$store.state.token; },
    mediaSrc() {
      const v = this.value || {};
      return v.s3_url || v.caption_media_url || v.media_url || "";
    },
  },
  methods: {
    hasValue(v) {
      if (this.type === "gender" && typeof v === "object" && v !== null) {
        return v.female_ratio !== null && v.female_ratio !== undefined && v.female_ratio !== "";
      }

      // cost / cost_setting: 0 は有値。null のみ未設定（REECH-3245）
      if (this.type === "cost" || this.type === "cost_setting") {
        return v !== null && v !== undefined && v !== "";
      }

      if (!this.editable) {
        const numericTypes = ["number", "percent", "refer", "refer_percent"];
        if (numericTypes.includes(this.type) && (v === 0 || v === "0")) return false;
      }

      return v !== null && v !== undefined && v !== "";
    },
    getRatioValue(v) {
      if (typeof v === 'object' && v !== null) return v.female_ratio;
      return v;
    },
    openCell(value) {
      this.open = true;
      if (value && value.match(/[0-9]/)) this.edit_value = value;
      else if (value === "Backspace") this.edit_value = "";
      else this.edit_value = this.value;

      setTimeout(() => {
        const el = document.getElementById("input-" + this.id);
        if (el) el.focus();
      }, 50);
    },
    /** cost の未設定入力（空欄）。0 は未設定ではない */
    isCostBlank(v) {
      return v === null || v === undefined || v === "";
    },
    /** セル値が変わったか。cost_setting は 0 と "" を別扱い（0 == "" 問題回避） */
    hasCellValueChanged() {
      if (this.type === "cost_setting") {
        const oldBlank = this.isCostBlank(this.value);
        const newBlank = this.isCostBlank(this.edit_value);
        if (oldBlank && newBlank) return false;
        if (oldBlank !== newBlank) return true;
        return Number(this.value) !== Number(this.edit_value);
      }
      return this.value != this.edit_value;
    },
    /** cost_setting の無入力は空文字 → API で null */
    costSendValue() {
      if (this.type === "cost_setting" && this.isCostBlank(this.edit_value)) {
        return "";
      }
      return this.edit_value;
    },
    editValue(presskey) {
      this.open = false;
      this.editing = true;
      if (this.hasCellValueChanged()) {
        this.$emit("syncValue", this.index, this.edit_value, this.column);
        const params = new URLSearchParams();
        params.append("token", this.token);
        params.append("report_id", this.report_id);
        params.append("media_id", this.media_id);
        params.append("column", this.column);
        params.append("value", this.costSendValue());
        params.append("sns_type", this.sns_type);
        this.axios.post(changeReportPostAPI, params).then((res) => {
          this.$emit("updateValue", this.index, res.data.new_post_data);
        });
      }
      this.$emit("finishEdit", presskey);
      setTimeout(() => (this.editing = false), 300);
    },
    imgError() {
      if (this.value) this.value.profile_picture_url = this.s3BaseUrl + "/userdata/img_error.png";
    },
    openInfluencer(account_name) {
      this.$emit("openInfluencer", account_name, this.sns_type);
    },
  },
  filters: {
    addComma(val) {
      if (val === "" || val === null || val === undefined) return "";
      if (isNaN(val)) return val;
      const n = Number(val);
      return Number.isInteger(n)
          ? n.toLocaleString()
          : n.toLocaleString(undefined, { maximumFractionDigits: 2 });
    },
    formatPercent(val) {
      if (val === null || val === undefined || val === "" || isNaN(val)) return val;
      return Math.round(Number(val) * 100) / 100;
    },
  },
};
</script>